<ng-container *ngIf="(formField?.errors && (formField?.dirty || formField?.touched))">
  <p class="error_s">
    {{listOfErrors()}}
  </p>
</ng-container>
